import React, { InputHTMLAttributes, useContext } from "react";

import styles from "./Input.module.css";
import ThemeContext from "~/contexts/ThemeContext";
import clsx from "clsx";

const Input: React.FC<InputHTMLAttributes<HTMLInputElement>> = ({
  disabled,
  ...props
}) => {
  const { template } = useContext(ThemeContext);

  // Styles
  const inputStyles = {
    backgroundColor: template.global.input.backgroundColour,
    borderColor: template.global.input.borderColour,
    color: template.global.input.fontColour,
    "--focus-input-background-colour":
      template.global.input.focusBackgroundColour,
    "--focus-input-border-colour": template.global.input.focusBorderColour,
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? "not-allowed" : "text",
  };

  return (
    <input
      disabled={disabled}
      {...props}
      className={clsx(styles.input, props.className)}
      style={{
        ...inputStyles,
        ...props.style,
      }}
    />
  );
};

export default Input;
